import { booleanAttribute, ChangeDetectionStrategy, Component, ElementRef, inject, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ButtonModule, IconModule, PopoverDirective, WithDigitGroupsPipe } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { OrganizationType, WalletCard } from '@kr/models';
import { CurrencyBalanceFormatPipe } from '@kr/pipes';
import { ClipboardService } from '@kr/services';

@Component({
  imports: [IconModule, WithDigitGroupsPipe, TranslateModule, ButtonModule, FormsModule, CurrencyBalanceFormatPipe, PopoverDirective],
  selector: 'kr-wallet-card',
  templateUrl: './wallet-card.component.html',
  styleUrls: ['./wallet-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalletCardComponent {
  elementRef = inject(ElementRef);
  clipboard = inject(ClipboardService);

  wallet = input.required<WalletCard>();
  walletName = input<string>();
  large = input(false, { transform: booleanAttribute });
  withEditBtn = input(false, { transform: booleanAttribute });
  editable = input(false, { transform: booleanAttribute });

  edit = output<void>();
  walletNameChange = output<string>();

  getOrganizationTypeInitial(type: OrganizationType): string {
    return type ? `(${type[0]})` : '';
  }

  dispatchClick(): void {
    this.elementRef.nativeElement.click();
  }
}
